import store from '@/store';
import i18n from '@/assets/js/i18n';

// 绑定函数 选择图片
export const bindtap_chooseImages = res => {
	return new Promise(resolve => {
		if (res.length) {
			// 单张覆盖
			if (!/image\/\w+/.test(res[0].file.type)) {
				store.dispatch('hideLoading');
				store.dispatch('showTooltip', { msg: i18n.t('请上传图片格式文件') });
				return false;
			}
			if (res[0].file.size >= 1024 * 1024 * 5) {
				// 限制上传尺寸小于1M
				store.dispatch('hideLoading');
				store.dispatch('showTooltip', { msg: i18n.t('上传文件太大，请重新上传') });
				return false;
			}
			if (res[0].file.size <= 0) {
				// 限制上传尺寸小于1M
				store.dispatch('hideLoading');
				store.dispatch('showTooltip', { msg: i18n.t('无效图片，请重新上传') });
				return false;
			}

			resolve(res);
			return;
		}
		store.dispatch('showTooltip', { msg: i18n.t('未选择上传图片') });
	});
};


export const handleOCRShow = res => {
	return new Promise(resolve => {
		const cardInfo = handleFillCardInfo(res);
		const cardInfoValues = Object.values(cardInfo)?.filter(item => item);
		if (!cardInfoValues.length) {
			resolve({ businessCard: res.viewUrl, cropBusinessCard: res.cropImage, cardInfo: {}, businessCardId: res.requestId });
			store.dispatch('showTooltip', { msg: i18n.t('识别失败，请重新上传或手动填写') });
			return;
		}
		const { name, company, position, telAreaCode, telephone, email } = cardInfo;
		const obj = {
			userName: name,
			institutionName: company,
			companyName: company,
			occupation: position,
			areaCode: telAreaCode || '+86',
			phoneNumber: telephone,
			email: email,
			businessCard: res.viewUrl,
			cropBusinessCard: res.cropImage,
			businessCardId: res.requestId
		};
		resolve({ ...obj, cardInfo });
	});
};


export const handleFillCardInfo = res => {
	const item_list = res.result?.item_list || [];
	const cardInfo = {
		'telephone': null, // 电话
		'email': null, // 邮箱
		'workTelAreaCode': null, // 工作电话地区码
		'address': null, // 地址
		'name': null, // 姓名
		'department': null, // 部门
		'telAreaCode': null, // 电话地区码
		'position': null, // 职位
		'companyEn': null, // 公司英文名
		'workTel': null, // 工作电话
		'company': null, // 公司,
		'family_name': null, // 姓
		'given_name': null // 名
	};
	if (res.code === 200 && res.result.type === 'business_card') {

		// 使用 Map 来记录已经处理过的 key，确保只取第一个值
		const processedKeys = new Set();

		item_list.forEach(item => {
			if (item.key === 'company' && item?.extra?.institutionList?.length && !processedKeys.has('company')) {
				cardInfo.company = item?.extra?.institutionList?.[0]?.fullName || item.value;
				processedKeys.add('company');
			}
			if (item.key === 'telephone' && item?.extra?.phoneCheckResult && !processedKeys.has('telephone')) {
				cardInfo.telAreaCode = item?.extra?.areaCode || '+86';
				cardInfo.telephone = item.value;
				processedKeys.add('telephone');
			}
			if (item.key === 'work_tel' && item?.extra?.phoneCheckResult && !processedKeys.has('work_tel')) {
				cardInfo.workTelAreaCode = item?.extra?.areaCode || '+86';
				cardInfo.workTel = item.value;
				processedKeys.add('work_tel');
			}
			if (item.key === 'name' && !processedKeys.has('name')) {
				cardInfo.name = item.value;
				processedKeys.add('name');
			}
			if (item.key === 'title' && !processedKeys.has('title')) {
				cardInfo.position = item.value;
				processedKeys.add('title');
			}
			if (item.key === 'department' && !processedKeys.has('department')) {
				cardInfo.department = item.value;
				processedKeys.add('department');
			}
			if (item.key === 'email' && item?.extra?.mailCheckResult && !processedKeys.has('email')) {
				cardInfo.email = item.value;
				processedKeys.add('email');
			}
			if (item.key === 'address' && !processedKeys.has('address')) {
				cardInfo.address = item.value;
				processedKeys.add('address');
			}
			if (item.key === 'companyEn' && !processedKeys.has('companyEn')) {
				cardInfo.companyEn = item.value;
				processedKeys.add('companyEn');
			}
			if (item.key === 'family_name' && !processedKeys.has('family_name')) {
				cardInfo.family_name = item.value;
				processedKeys.add('family_name');
			}
			if (item.key === 'given_name' && !processedKeys.has('given_name')) {
				cardInfo.given_name = item.value;
				processedKeys.add('given_name');
			}
		});

		if (!cardInfo.telephone && cardInfo.workTel) {
			cardInfo.telephone = cardInfo.workTel;
			cardInfo.telAreaCode = cardInfo.workTelAreaCode
		}

	}

	return cardInfo;
};